import React, { useCallback, useEffect } from 'react'
import Popup from '../../../../../components/popup/Popup'
import General from '../../../../../../libs/utility/General'
import styles from "./StateFiling.styles"
import Button from '../../../../../components/button/Button'
import PaymentDrawer from '../../../../components/paymentdrawer/PaymentDrawer'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setPaymentDrawerModal } from './StateFilingSlice'
import useGarbageCollector from '../../../../../../libs/garbagecollector/garbageCollectorHooks'
import { PLACE_OF_ORIGIN_FOR_PAYMENT } from '../../../../components/paymentdrawer/constants'
import ManageFormsService from '../../../../../../services/ManageFormsService'
import Loadable from '../../../../../components/loadable/Loadable'
import { getStateFilingAmount } from './StateFilingSaga'
import { addNotifications } from '../../../../toaster/ToasterPortalSlice'
import { TOASTER_VARIANT } from '../../../../../components/toast/constants'

export const StateFiling = ({ isOpen, title, onCloseCb, selectedRows = [], gridData = [] }) => {

    useGarbageCollector(componentKey);
    const { loadingState, stateFilingAmount } = useSelector(state => state[componentKey]);
    const dispatch = useDispatch();

    useEffect(() => {
        if (selectedRows?.every(row => row?.IsState == true) || General.checkFederalFormsStateFiling(selectedRows)) {
            dispatch(getStateFilingAmount({ selectedRows }))
        }
    }, [])

    const renderBody = useCallback(() => {

        if (!selectedRows?.every(row => row?.IsState == true)) {
            return renderMessageBox("Select state row check boxes");
        } else if (!General.checkFederalFormsStateFiling(selectedRows)) {
            return renderMessageBox("Select only those reference number which has W-2, 1099-Misc, 1099-NEC,1099-B,1099-R,1099-K,1095-B or 1095-C Forms");
        } else if (General.checkReferenceNumbers(selectedRows)) {
            return renderMessageBox("Select forms with the same reference number");
        }
        else {
            return renderMessageBox("Something went wrong!");
        }

    }, [selectedRows, gridData])

    const renderMessageBox = (message) => {
        return <div style={styles.messageBox}>
            <p style={styles?.bodyText}>{message}</p>
            <Button onClickCb={onCloseCb} style={styles.button}>Ok</Button>
        </div>
    }

    return (
        <>

            {!selectedRows?.every(row => row?.IsState == true) || !General.checkFederalFormsStateFiling(selectedRows) ? <Popup
                isPopupOpen={isOpen}
                title={title}
                onCloseCb={onCloseCb}
                children={renderBody()}
                showClose={false}
                showHeader={false}
            /> :
                <PaymentDrawer
                    isOpen={isOpen}
                    onCloseCb={() => onCloseCb()}
                    filingFeeLabel={`State Filing Fee`}
                    calculatePrepaySalesTax={true}
                    fees={stateFilingAmount}
                    paymentServiceFunctionCb={ManageFormsService.stateFilingPayment}
                    onPaymentSuccessCb={() => { 
                        dispatch(addNotifications({ heading: "Success", message: `State Filing successful`, variant: TOASTER_VARIANT.SUCCESS }))
                        onCloseCb()
                    }}
                    placeOfOriginforpayment={PLACE_OF_ORIGIN_FOR_PAYMENT.SF_PAYMENT}
                    paymentServiceFunctionExtraParams={{
                        jsonPreferences: selectedRows.map(record => {
                            return {
                                key: "true",
                                ReferenceId: record?.ReferenceNumber,
                                formtype: record?.FormName,
                                PayerId: record?.EncryptedPayerId
                            }
                        })
                    }}
                />
            }
        </>
    )
}
